<template>
  <a :href="`https://www.google.nl/search?q=${title}`" target="_blank">
    <svg @click="handleClick" :fill="color" stroke="#2c3e50" width="100pt" height="100pt" version="1.1"
         viewBox="0 0 100 100"
         xmlns="http://www.w3.org/2000/svg" style="width: 80px">
      <path
        d="m49.5 91.602s-48.398-19.801-48.398-55.898c-0.10156-15.102 11.5-27.305 25.797-27.305 10.102 0 18.902 6.2031 23.102 15.203 4.1992-9 13-15.199 23.102-15.199 14.297-0.003906 25.898 12.199 25.898 27.297 0 35.902-49.5 55.902-49.5 55.902z"/>
    </svg>
  </a>
</template>

<script>
  export default {
    name: 'Star',
    props: [
      'title'
    ],
    methods: {
      handleClick () {
        this.color = this.color === 'red' ? 'transparent' : 'red'
      }
    },
    data () {
      return {
        color: 'transparent'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Star.vue